/** Неделя виджета «Сегодня» (2026-10-21): календарь пн–вс по МСК из последних семи дней сервера. */

/** День недели по МСК (пн = 0 … вс = 6): серия и неделя на сервере тоже московские. */
export function mskWeekday(now: number = Date.now()): number {
  const day = new Date(now + 3 * 3600 * 1000).getUTCDay(); // 0 — воскресенье
  return (day + 6) % 7;
}

/** Календарная неделя пн–вс из последних 7 дней сервера (шесть дней назад … сегодня); будущие дни — null. */
export function calendarWeek(lastSevenDays: boolean[], weekday: number): (boolean | null)[] {
  const days = lastSevenDays.length === 7 ? lastSevenDays : Array.from({ length: 7 }, () => false);
  return Array.from({ length: 7 }, (_, d) => (d > weekday ? null : days[6 - (weekday - d)]));
}
